import {
  createSetBookingProfile,
  createSetBookingToken,
  createSetBookingEmail,
  createSetBookingType,
} from './setBookingProfile';
import { bookingProfileVar } from '../reactiveVariables';

export const setBookingProfile = createSetBookingProfile(bookingProfileVar);
export const setBookingToken = createSetBookingToken(bookingProfileVar);
export const setBookingEmail = createSetBookingEmail(bookingProfileVar);
export const setBookingType = createSetBookingType(bookingProfileVar);
